import { useMemo } from "react";
import Select from "../common/components/Select"
import useClientConfig from "../common/hooks/clientConfigHook"

const ChannelDropdown = ({ ...props }) => {
    const clientConfig = useClientConfig();
    const options = useMemo(() => {
        const options = [{label: 'None', value: null},{label:'SMS',value: 'SMS'}]
        if (false && clientConfig.emailJobType) {
            options.push({label:'Email',value:'Email'});
        }
        return options;
    }, [clientConfig])

    return <Select options={options} labelField="label" valueField="value" {...props}></Select>
}

export default ChannelDropdown;